module.exports = __webpack_public_path__ + "static/media/spanidea-logo.ec7ac65c.svg";